import { useNavigate } from "react-router-dom";
import { PageHeader } from "@/screens/_shared";

/**
 * Simple info/placeholder screens reachable from Settings (Help / Report / About).
 * Not dead UI — each explains what's coming or shows basic info.
 */

export const HelpCenter = () => {
    return (
        <div className="screen" data-testid="help-screen">
            <PageHeader title="Help Center" />
            <div className="flex-1 overflow-y-auto no-scrollbar px-5 py-5 space-y-3">
                <Faq q="How do I verify my account?" a="Go to Settings → Verification, choose your type and upload a valid ID + selfie. Approval takes up to 2 minutes." />
                <Faq q="What do Premium users get?" a="Higher visibility, priority ranking, Insights, more message requests, contact reveal, and a Premium badge." />
                <Faq q="How do withdrawals work?" a="Add a bank account under Payout Methods, then withdraw from your Wallet. You'll get a reference ID on completion." />
                <Faq q="Is my data private?" a="All Neyra data lives on-device in this build. No servers, no sharing." />
            </div>
        </div>
    );
};

const Faq = ({ q, a }) => (
    <div className="p-4 rounded-2xl border border-border bg-card shadow-soft">
        <div className="font-display text-[14px] font-semibold">{q}</div>
        <p className="mt-1 text-[12.5px] text-muted-foreground leading-snug">{a}</p>
    </div>
);

export const ReportProblem = () => {
    return (
        <div className="screen" data-testid="report-screen">
            <PageHeader title="Report a Problem" />
            <div className="flex-1 overflow-y-auto no-scrollbar px-5 py-5">
                <p className="text-[13px] text-muted-foreground">
                    Tell us what went wrong and we'll look into it.
                </p>
                <textarea
                    data-testid="report-textarea"
                    rows={6}
                    maxLength={500}
                    placeholder="Describe the issue…"
                    className="mt-3 w-full p-3.5 rounded-2xl border border-border bg-secondary focus:bg-background focus:border-primary outline-none text-[14px] resize-none"
                />
                <button
                    data-testid="report-submit"
                    onClick={() => alert("Thanks — we've logged your report.")}
                    className="mt-3 w-full h-12 rounded-2xl bg-primary text-primary-foreground font-medium text-[14px] active:scale-[0.98]"
                >
                    Submit report
                </button>
            </div>
        </div>
    );
};

export const About = () => (
    <div className="screen" data-testid="about-screen">
        <PageHeader title="About Neyra" />
        <div className="flex-1 overflow-y-auto no-scrollbar px-5 py-5 text-center">
            <img src="/logo.png" alt="Neyra" className="h-16 w-16 mx-auto" />
            <h2 className="mt-3 font-display text-[18px] font-semibold">Neyra</h2>
            <p className="text-[12.5px] text-muted-foreground">Version 1.0</p>
            <p className="mt-4 text-[13px] text-muted-foreground max-w-xs mx-auto">
                Discover events, services, and people near you — all in one beautifully simple app.
            </p>
        </div>
    </div>
);
